import React from "react";
import styles from "./ReusablePopup.module.css";

const ReusablePopup = ({
  isOpen,
  onClose,
  onConfirm,

  icon,
  heading,
  subtext,
  paragraph,

  showCancel = true,
  showConfirm = true,

  cancelText = "Cancel",
  confirmText = "OK",

  iconColor = "#4f46e5",
  iconBG = "#bfbbff",

  // NEW: optional inline input
  showInput = false,
  inputValue = "",
  onInputChange,
  inputPlaceholder = "",
  inputType = "text",
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles["popup-overlay"]} onClick={onClose}>
      <div
        className={styles["popup-container"]}
        onClick={(e) => e.stopPropagation()}
      >
        {icon && (
          <div
            className={styles["popup-icon"]}
            style={{ color: iconColor, background: iconBG }}
          >
            {icon}
          </div>
        )}
        {heading && <h2 className={styles["popup-heading"]}>{heading}</h2>}
        {subtext && <h4 className={styles["popup-subtext"]}>{subtext}</h4>}
        {paragraph && <p className={styles["popup-paragraph"]}>{paragraph}</p>}

        {showInput && (
          <input
            className={styles["popup-input"]}
            type={inputType}
            value={inputValue}
            placeholder={inputPlaceholder}
            onChange={(e) => onInputChange?.(e.target.value)}
            autoFocus
          />
        )}

        {(showCancel || showConfirm) && (
          <div className={styles["popup-actions"]}>
            {showCancel && (
              <button className={styles["popup-cancel-btn"]} onClick={onClose}>
                {cancelText}
              </button>
            )}
            {showConfirm && (
              <button
                className={styles["popup-confirm-btn"]}
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReusablePopup;